import React from "react";
import googleClone from "../assets/portfolio/GoogleClone.png";
import voiceTranslator from "../assets/portfolio/VoiceTranslator.png";
import linkedin from "../assets/portfolio/Linkedin.png";
import chatApp from '../assets/portfolio/ChatAppSS.png';

const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: linkedin,
      href: "https://linkedin-clone-ethan.netlify.app/",
      name: "Linkedin Clone",
      skills: "JavaScript, Material-UI, React.js, Redux, Axios, Node.js, Express.js, MySQL",
      codeHref: "https://github.com/ethanpv34/Linkedin-Clone-Client",
    },
    {
      id: 2,
      src: chatApp,
      href: "https://chat-app-ethanpv34.netlify.app/",
      name: "Chat App",
      skills: "JavaScript, HTML, CSS, React.js, Node.js, Express.js, Socket.io",
      codeHref: "https://github.com/ethanpv34/Chat-App-Client",
    },
    {
      id: 3,
      src: googleClone,
      href: "https://google-clone-ethan.netlify.app/",
      name: "Google Clone",
      skills: "TypeScript, React.js, Axios, Material-UI",
      codeHref: "https://github.com/ethanpv34/Google-Clone"
    },
    {
      id: 4,
      src: voiceTranslator,
      href: "https://voice-language-translator.netlify.app/",
      name: "Voice Translator",
      skills: "JavaScript, HTML, CSS, React.js",
      codeHref: "https://github.com/ethanpv34/Voice-Translator"
    },

  ];

  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Check out some of my work right here (Note: backends/API keys may be expired as of 2024, feel free to check out the repos!):</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 px-12 sm:px-0">
          {portfolios.map(({ id, src, href, name, skills, codeHref }) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg h-35">
              <h3 className="flex items-center justify-center font-semibold text-xl">{name}</h3>
              <img
                src={src}
                alt=""
                className="rounded-md duration-200 hover:scale-105"
              />
              <div className="flex items-center justify-center">
                <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 font-bold">
                  <a href={href}>Demo</a>
                </button>
                <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 font-bold">
                  <a href={codeHref}>Code</a>
                </button>
              </div>
              <div className="flex items-center justify-center h-15">
                <p className="text-sm text-center">Skills used: {skills}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
